<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        clienteid: '',
        tipopedidoid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      clientesOptions: [],
      loadingClientes: false,
      dataFromApiTipoPedidoId: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTipoPedido();
    },
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
    async onSearchCliente(search) {
      if (!search) {
        this.clientesOptions = [];
        return;
      }
      this.loadingClientes = true;
      try {
        const response = await axios.get(`/cliente?q=${encodeURIComponent(search)}&perPage=20`);
        this.clientesOptions = response.data.data;
      } catch (e) {
        this.clientesOptions = [];
      } finally {
        this.loadingClientes = false;
      }
    },
    async fetchDataFromTipoPedido() {
      try {
        const response = await axios.get('/tipo-pedido');
        this.dataFromApiTipoPedidoId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.tipopedidoid === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Cliente"
                label-for="clienteid"
            >
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <v-select
                  v-model="dataForm.clienteid"
                  :options="clientesOptions"
                  :reduce="item => item.clienteid"
                  label="clientenomefantasia"
                  placeholder="Digite o nome ou código do cliente"
                  :filterable="false"
                  :loading="loadingClientes"
                  @search="onSearchCliente"
                  :class="{'is-invalid': errors.length > 0}"
                  id="clienteid"
                >
                  <template #no-options>
                    Digite o nome ou código do cliente
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Pedido"
                label-for="tipopedidoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipopedidoid"
                    id="tipopedidoid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiTipoPedidoId"
                    value-field="tipopedidoid"
                    text-field="tipopedidodescricao"
                    placeholder="Selecione um tipo pedido"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
